import { useState } from "react";

export type Selection<T> = {
	selectedItems: T[];
	handleSelectItem: (object: T, checked: boolean) => void;
	handleSelectAll: (checked: boolean) => void;
	isSelectedItem: (object: T) => boolean;
	isAllSelected: () => boolean;
};

type SelectionProps<T> = {
	data: T[];
	initialSelectedItems?: T[];
};

export function useSelection<T>({
	data,
	initialSelectedItems,
}: SelectionProps<T>): Selection<T> {
	const [selectedItems, setSelectedItems] = useState<T[]>(
		initialSelectedItems || []
	);

	function handleSelectItem(object: T, checked: boolean) {
		if (checked) {
			setSelectedItems([...selectedItems, object]);
		} else {
			setSelectedItems(selectedItems.filter((item) => item !== object));
		}
	}

	function handleSelectAll(checked: boolean) {
		if (!checked) {
			setSelectedItems([]);
		} else {
			setSelectedItems(data);
		}
	}

	function isAllSelected() {
		return selectedItems.length === data.length && data.length > 0;
	}

	function isItemSelected(object: T) {
		return selectedItems.includes(object);
	}

	return {
		selectedItems,
		handleSelectItem,
		handleSelectAll,
		isSelectedItem: isItemSelected,
		isAllSelected,
	};
}
